import Plugin from "@ckeditor/ckeditor5-core/src/plugin"
import InsertImageWithoutIsbnUI from "./insertimagewithoutisbnui"
import InsertImageWithoutIsbnEditing from "./insertimagewithoutisbnediting"

export default class InsertImageWithoutIsbn extends Plugin {
  static get requires() {
    return [InsertImageWithoutIsbnUI, InsertImageWithoutIsbnEditing]
  }

  static get pluginName() {
    return "InsertImageWithoutIsbn"
  }
}
